import apiClient from './api.client';

const SuperAdminService = {
  getStats: async () => {
    const res = await apiClient.get('/super-admin/stats');
    return res.data;
  },

  listAccounts: async (search) => {
    const res = await apiClient.get('/super-admin/accounts', {
      params: search ? { search } : undefined,
    });
    return res.data;
  },

  listLeads: async (search) => {
    const res = await apiClient.get('/super-admin/leads', {
      params: search ? { search } : undefined,
    });
    return res.data;
  },

  getAccount: async (id) => {
    const res = await apiClient.get(`/super-admin/accounts/${id}`);
    return res.data;
  },

  createAccount: async (payload) => {
    const res = await apiClient.post('/super-admin/accounts', payload);
    return res.data;
  },

  updateAccount: async (id, payload) => {
    const res = await apiClient.patch(`/super-admin/accounts/${id}`, payload);
    return res.data;
  },

  resetAdminPassword: async (id, password) => {
    const res = await apiClient.patch(`/super-admin/accounts/${id}/admin-password`, { password });
    return res.data;
  },

  changeOwnPassword: async (password) => {
    const res = await apiClient.patch('/super-admin/me/password', { password });
    return res.data;
  },

  listAiModels: async (activeOnly = false) => {
    const res = await apiClient.get('/super-admin/miranda/models', {
      params: activeOnly ? { activeOnly: 'true' } : undefined,
    });
    return res.data;
  },

  createAiModel: async (payload) => {
    const res = await apiClient.post('/super-admin/miranda/models', payload);
    return res.data;
  },

  updateAiModel: async (id, payload) => {
    const res = await apiClient.patch(`/super-admin/miranda/models/${id}`, payload);
    return res.data;
  },

  getAccountAi: async (accountId) => {
    const res = await apiClient.get(`/super-admin/miranda/accounts/${accountId}`);
    return res.data;
  },

  upsertAccountAi: async (accountId, payload) => {
    const res = await apiClient.patch(`/super-admin/miranda/accounts/${accountId}`, payload);
    return res.data;
  },

  generateAccountReport: async (accountId, daysAgo = 1) => {
    const res = await apiClient.post(
      `/super-admin/miranda/accounts/${accountId}/reports/generate`,
      null,
      { params: { daysAgo } },
    );
    return res.data;
  },

  getFeatureCatalog: async () => {
    const res = await apiClient.get('/super-admin/feature-catalog');
    return res.data;
  },

  listPlans: async (includeInactive = true) => {
    const res = await apiClient.get('/super-admin/plans', {
      params: { includeInactive: includeInactive ? 'true' : 'false' },
    });
    return res.data;
  },

  getPlan: async (id) => {
    const res = await apiClient.get(`/super-admin/plans/${id}`);
    return res.data;
  },

  createPlan: async (payload) => {
    const res = await apiClient.post('/super-admin/plans', payload);
    return res.data;
  },

  updatePlan: async (id, payload) => {
    const res = await apiClient.patch(`/super-admin/plans/${id}`, payload);
    return res.data;
  },

  updatePlanFeatures: async (id, features) => {
    const res = await apiClient.patch(`/super-admin/plans/${id}/features`, { features });
    return res.data;
  },

  anonymizeLead: async (payload) => {
    const res = await apiClient.post('/super-admin/privacy/anonymize-lead', payload);
    return res.data;
  },

  anonymizeCustomer: async (payload) => {
    const res = await apiClient.post('/super-admin/privacy/anonymize-customer', payload);
    return res.data;
  },
};

export default SuperAdminService;
